import axios from 'axios';

export const style = {
  DARK: {},
  LIGHT: {
    primary: '#052965',
    secondary: '#fff',
    background: {
      main: '#4f82b0',
      secondary: '#E2E5DE',
      light: '#DCE6EE'
    },
    text: {
      main: '#052965',
      secondary: '#489840'
    },
    Success: '#008000',
    error: 'rgb(220 38 38)',
    neutral: '#E2E5DE',
    recommended1: '#68D873',
    recommended2: '#B3ECA9'
  },
  fontFamily: 'sans-serif',
  backgroundColor: '#4f82b0',
  textColor: '#052965',
  textGreen: '#489840',
  pink: '#b3854b',
  yellow: '#0083a1',
  purple: '#a1698c',
  blue: '#5295b1',
  green: '#779a40',
  recommended1: '#68D873',
  recommended2: '#B3ECA9',
  grayBackground: '#E2E5DE'
};

export const PLACEHOLDER_IMG_SRC = '/productImgs/placeholder.png';
export const PDF_RENDER_TIME_DELAY_MS = 5000;
export const CALCULATOR_MAX_INPUT_VAL = 99999;

export const schemeColorsMap = {
  black: '#000000',
  green: '#28C76F',
  grey: {
    100: '#9298A6',
    200: '#3A4459',
    300: '#c8c8c8'
  },
  red: '#B2363E'
};

export const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${REACT_APP_BACKEND_URL}/api/`
});

export const authorizedApi = (token) =>
  axios.create({
    baseURL: `${REACT_APP_BACKEND_URL}/api/`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
